<template>
    <div>
        <label class="acrd-text-two font-small" :for="name">{{label}}<span v-if="required == 'true' || required == true" class="text-red-600">*</span></label>
        <div v-if="login == 'true'" class="input-group">
            <div class="input-group-prepend bg-transparent">
                <span class="form-control-lg input-group-text bg-transparent border-right-0 accred-icon-text">
                    <feather type="user" class="color-grey"></feather>
                </span>
            </div>
            <input v-if="login == 'true'" :required="required == 'true' || required == true" :placeholder="label" :type="setType()" :name="name" class="form-control form-control-lg border-left-0 accred-form-control" :class="validated ? 'bg-success-textbox' : ''" :default-value.prop="value != null ? value : ''" v-on:input="updateValue($event.target.value)">
        </div>
        <div v-else class="input-group">
            <input :required="required == 'true' || required == true" :placeholder="label" :type="setType()" :name="name" class="form-control form-control-lg border-left-0" :class="validated ? 'bg-success-textbox' : ''" :default-value.prop="value != null ? value : ''" v-on:input="updateValue($event.target.value)">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'textbox',
        props: ['login', 'value', 'label', 'name', 'required', 'validated','error','field'],
        components: { },
        watch: {
        },
        mounted() {
            console.log(this.field);
        },
        methods: {
            updateValue: function (value) {
                this.$emit('input', value);
            },
            setType: function(){
                switch(this.name){
                    case "email_phone": 
                        return "text";
                    case "otp_str":
                        return "text";
                    case "username":
                        return "text";
                    case "numeric":
                        return "numeric";
                    case "password": 
                        return "password";
                    case "password_confirmation": 
                        return "password";
                    default:
                        return "text";
                }
            }
        }
    }
</script>